// extracted by mini-css-extract-plugin
export default {"ad":"index_ad_5WUum","box":"index_box_Y7V1b","footer":"index_footer_JlXVf"};